import React from "react";

export const SLASH_PAGE = "SLASH_PAGE";
export const HOME_PAGE = "HOME_PAGE";
export const GPS_PAGE = "GPS_PAGE";
export const THEME_PAGE = "THEME_PAGE";
export const MENTION_PAGE = "MENTION_PAGE";

export const STATIC_PAGES = [SLASH_PAGE, HOME_PAGE, MENTION_PAGE];